import React from "react";
import { Button } from "@mui/material";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";

function TrialDialog({ onClose }) {
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing={3} alignItems="center" justifyContent="center">
          <Typography variant="h6" sx={{ color: "red", textAlign: "center" }}>
            Your trial has been expired
          </Typography>
          <Typography sx={{ textAlign: "center" }}>
            Kindly contact sales department for payment
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing="10px">
            <Typography sx={{ color: "#4eaf51" }}>WhatsApp :</Typography>
            <Typography sx={{ color: "#4eaf51" }}>+923315921209</Typography>
          </Stack>
          <Button
            variant="contained"
            sx={{ background: "rgb(138, 138, 138) !important" }}
            onClick={onClose}
          >
            Close
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default TrialDialog;
